var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "column is-half is-offset-one-quarter"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._l((_vm.frameworks), function(option) {
    return _c('div', {
      key: option.title,
      staticClass: "field"
    }, [_c('div', {
      staticClass: "control"
    }, [_c('label', {
      staticClass: "checkbox",
      attrs: {
        "for": "vote"
      }
    }, [(!_vm.voted) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.checkedVotes),
        expression: "checkedVotes"
      }],
      attrs: {
        "type": "checkbox",
        "name": "vote"
      },
      domProps: {
        "value": option,
        "checked": Array.isArray(_vm.checkedVotes) ? _vm._i(_vm.checkedVotes, option) > -1 : (_vm.checkedVotes)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.checkedVotes,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = option,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.checkedVotes = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.checkedVotes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.checkedVotes = $$c
          }
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": option.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(option.title) + " (" + _vm._s(option.votes) + ")")])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('div', {
    staticClass: "control"
  }, [(!_vm.voted) ? _c('button', {
    staticClass: "button is-primary",
    class: {
      'is-loading': _vm.dataLoading
    },
    on: {
      "~click": function($event) {
        _vm.addVote($event)
      }
    }
  }, [_vm._v("Submit")]) : _vm._e()])])], 2)])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6821ff76","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Vote.vue
// module id = jZfS
// module chunks = 1